import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  useBreakpointValue,
  Link as ChakraLink,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { Pagination } from "../../components/Pagination";
import { Link } from "react-router-dom";
import format from "date-fns/format";
import { api } from "../../services/api";
import { intervalToDuration } from "date-fns";
import { RiArrowRightSLine } from "react-icons/ri";
import { AiOutlineFilePdf } from "react-icons/ai";
import Loading from "../../components/Loading";
import { maskCPF } from "../../utils/mask";
import { MdSearch } from "react-icons/md";
import InputMask from "react-input-mask";

interface event {
  _id: string;
  user: {
    name: string;
    cpfCnpj: string;
  };
  type: string;
  startedAt: Date;
  finishedAt: Date;
  duration: string;
}
interface Response {
  _id: string;
  user: {
    name: string;
    cpfCnpj: string;
  }[];
  type: string;
  startedAt: string;
  finishedAt: string;
}

export default function Registry() {
  const [list, setList] = useState<event[]>([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const isMdVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  const isSmVersion = useBreakpointValue({
    base: false,
    sm: true,
  });
  const [user, setUser] = useState("");

  const loadList = async (pageNumber: number = 1) => {
    const { data } = await api.get("/events", {
      params: {
        page: pageNumber,
        cpf: user ? user : "",
      },
    });
    const dataFormatted = data.data.map((item: Response) => ({
      ...item,
      user: { ...item.user[0], cpfCnpj: maskCPF(item.user[0].cpfCnpj) },
    }));
    setTotalData(data.pageInfo.count);
    setList(dataFormatted);
  };

  useEffect(() => {
    loadList();
  }, []);

  const handlePageChange = (pageNumber: number) => {
    loadList(pageNumber);
  };

  const handleGenerateReport = async (eventId: string) => {
    setIsLoading(true);
    const response = await api.get(`/report/${eventId}`, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "relatório.pdf");
    link.click();
    setIsLoading(false);
  };

  function verifyDuration(value: any) {
    var arr = value.split("h");
    //@ts-ignore
    var dec = parseInt((arr[1] / 6) * 10, 10);

    const a = parseFloat(
      parseInt(arr[0], 10) + "." + (dec < 10 ? "0" : "") + dec
    );

    if (a > 5) {
      return {
        color: "red.600",
      };
    }

    return {
      color: "white",
    };
  }

  return (
    <>
      <Flex direction="column" minH="100vh" bg="bg">
        <Header />

        <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"}>
          <Sidebar />

          <Box
            overflowX="auto"
            flex="1"
            borderRadius={8}
            bg="gray"
            p="6"
            mb="5"
          >
            <Flex mb="8" justify="space-between" align="center">
              <Heading fontSize="21" fontWeight="400" color="text">
                Registros
              </Heading>

              <InputGroup size="md" width="300px">
                <Input
                  bg="gray.900"
                  pr="4.5rem"
                  placeholder="digite o CPF"
                  as={InputMask}
                  mask="***.***.***-**"
                  //@ts-ignore
                  maskChar={null}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      loadList();
                    }
                  }}
                  onChange={(e) => setUser(e.target.value)}
                />
                <InputRightElement width="4.5rem">
                  <Button h="1.75rem" size="sm" onClick={() => loadList()}>
                    <MdSearch />
                  </Button>
                </InputRightElement>
              </InputGroup>
            </Flex>

            <Table colorScheme="whiteAlpha">
              <Thead>
                <Tr color="gray_light">
                  <Th fontWeight="600" fontSize="12" p={"1"}>
                    Nome
                  </Th>
                  <Th fontWeight="600" fontSize="12" p={"1"}>
                    CPF
                  </Th>
                  <Th
                    fontSize="12"
                    fontWeight="600"
                    textAlign={"center"}
                    p={"1"}
                  >
                    Tipo
                  </Th>
                  {isSmVersion && (
                    <Th
                      fontSize="12"
                      fontWeight="600"
                      textAlign={"center"}
                      p={"1"}
                    >
                      Ínicio
                    </Th>
                  )}
                  {isSmVersion && (
                    <Th
                      fontSize="12"
                      fontWeight="600"
                      textAlign={"center"}
                      p={"1"}
                    >
                      Fim
                    </Th>
                  )}
                  {isWideVersion && (
                    <Th
                      fontSize="12"
                      fontWeight="600"
                      textAlign={"center"}
                      p={"1"}
                    >
                      Tempo de estadia
                    </Th>
                  )}
                  {isWideVersion && (
                    <Th
                      fontSize="12"
                      fontWeight="600"
                      textAlign={"center"}
                      p={"1"}
                    >
                      Ação
                    </Th>
                  )}
                </Tr>
              </Thead>
              <Tbody>
                {list.map((item) => (
                  <Tr h={"10"} color={verifyDuration(item.duration).color}>
                    <Td px={"1"} py={"4"}>
                      <Box>
                        <Text lineHeight="1.1" fontSize={"small"}>
                          {item.user.name}
                        </Text>
                      </Box>
                    </Td>
                    <Td px={"1"} py={"4"}>
                      <Box>
                        <Text lineHeight="1.1" fontSize={"small"}>
                          {item.user.cpfCnpj}
                        </Text>
                      </Box>
                    </Td>
                    <Td textAlign={"center"}>
                      {item.type === "load" ? "Carregamento" : "Descarga"}
                    </Td>
                    {isSmVersion && (
                      <Td textAlign={"center"}>
                        {format(
                          new Date(item.startedAt),
                          "dd/MM/yyyy HH:mm:ss"
                        )}
                      </Td>
                    )}
                    {isSmVersion && (
                      <Td textAlign={"center"}>
                        {format(
                          new Date(item.finishedAt),
                          "dd/MM/yyyy HH:mm:ss"
                        )}
                      </Td>
                    )}
                    {isWideVersion && (
                      <Td
                        // color={verifyDuration(item.duration).color}
                        textAlign={"center"}
                        fontSize={"small"}
                      >
                        {item.duration}
                      </Td>
                    )}
                    {isWideVersion && (
                      <Td>
                        <Flex alignItems="center" justifyContent="center">
                          <Button
                            onClick={() => handleGenerateReport(item._id)}
                          >
                            <Icon as={AiOutlineFilePdf} fontSize="29" />
                          </Button>
                          <Link
                            id="another"
                            style={{
                              textDecoration: "none",
                            }}
                            //@ts-ignore
                            to={`/registry/${item._id}`}
                          >
                            <ChakraLink
                              display="flex"
                              alignItems="center"
                              padding={2}
                              _hover={{
                                color: "white",
                                borderRadius: "4",
                                padding: 2,
                              }}
                            >
                              <Icon as={RiArrowRightSLine} fontSize="29" />
                            </ChakraLink>
                          </Link>
                        </Flex>
                      </Td>
                    )}
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Pagination
              total={totalData}
              totalPerPage={10}
              onChange={handlePageChange}
            />
          </Box>
        </Flex>
      </Flex>
      {isLoading && <Loading />}
    </>
  );
}
